<template>

    <div class="homelobby">

        <div class="home">

            <!-- The video background -->
            <video autoplay loop muted id="videobg" :key="vid1">
                <source src="https://gc-static-content.s3.amazonaws.com/merz-virtual/VeeamLiveLobby01.mp4" type="video/mp4">
            </video>

            <iframe :src="magicLink">

            </iframe>

            <!-- Use a button to mute/unmute the video with JavaScript -->
            <div class="vidcontent">
                <button id="vidBtn" v-on:click="vidAudioTrigger">Unmute</button>
            </div>

            <div class="menu">
                <!--<div class="menu1">
                    <div class="menutext">
                        <h1>Veeam Booth</h1>
                        <p>Product Demos <br>
                        Entertainment <br>
                        and more</p>
                    </div>

                    <a :href="'https://veeambooth.com/veeamlive/?userId='+ticketNumber+'&domain=veeamlive.com'" target="_blank">
                        <div id="hotSpot1" class="hotSpots"></div>
                    </a>
                </div>-->

                <div class="menu2">
                    <div class="menutext">
                        <h1>Community</h1>
                        <p>Meet and connect with <br> like-minded professionals</p>
                    </div>
                    <a><router-link to="/community">
                        <div id="hotSpot2" class="hotSpots"></div>
                    </router-link></a>
                </div>

                <!--<div class="menu3">
                    <div class="menutext">
                        <h1>Trivia Challenge</h1>
                    </div>
                    <a><router-link to="/trivia">
                        <div id="hotSpot3" class="hotSpots"></div>
                    </router-link></a>
                </div>-->
            </div>

            <a><router-link to="/agenda">
                <div id="hotSpot4" class="hotSpots"></div>
            </router-link></a>
            <a @click="zeTrigger"><router-link to="">
                <div id="hotSpot5" class="hotSpots"></div>
            </router-link></a>
        </div>


        <div class="mobileHomeLobby">
            <div class="menuMobile">
                
                <!--<a :href="'https://veeambooth.com/veeamlive/?userId='+ticketNumber+'&domain=veeamlive.com'" target="_blank">
                    <div class="menu1Mobile">
                        <div class="menutextMobile">
                            <h1>Veeam Booth</h1>
                            <p>Product Demos<br>Entertainment<br>and more</p>
                        </div>
                    </div>
                </a>-->

                <a><router-link to="/community">
                    <div class="menu2Mobile">
                        <div class="menutextMobile">
                            <h1>Community</h1>
                            <p>Meet and connect with like-minded professionals</p>
                        </div>
                    </div>
                </router-link></a>

                <!--<a><router-link to="/trivia">
                    <div class="menu3Mobile">
                        <div class="menutextMobile">
                            <h1>Trivia Challenge</h1>
                        </div>
                    </div>
                </router-link></a>-->

                <a><router-link to="/agenda">
                    <div class="menu4Mobile">
                        <div class="menutextMobile">
                            <h1>Sessions</h1>
                        </div>
                    </div>
                </router-link></a>

                <a @click="zeTrigger"><router-link to="">
                    <div class="menu5Mobile">
                        <div class="menutextMobile">
                            <h1>Veeam Help Desk</h1>
                        </div>
                    </div>
                </router-link></a>

            </div>
        </div>

    </div>

</template>






<script>

    /*import vid1 from "../assets/VeeamLiveLobby01.mp4"*/

    export default {
        name: "HomeLobby",
        data () {
            return {
                /*vid1,*/
                magicLink: localStorage.getItem('magicLink'),
                userId : localStorage.getItem('user_id'),
                ticketNumber : localStorage.getItem('ticketNumber')
            }
        },
        methods: {
            vidAudioTrigger: function () {

                var vid = document.getElementById("videobg");
                var btn = document.getElementById("vidBtn");

                if (vid.muted === true) {
                    vid.muted = false; 
                    btn.innerText = "Mute";
                    } else {
                    vid.muted = true;
                    btn.innerText = "Unmute";
                }
            },
            zeTrigger: function () {
                this.$zendesk.show();
                this.$zendesk.open();
            }
        },

        created () {
            let userID = localStorage.getItem('user_id');

            this.$ga.set({'dimension1': userID})
            this.$ga.set({'user_id': userID})

            console.log("user_id"+ userID);
        }
    }

</script>






<style scoped>

    /*Load Font*/
    @font-face {
        font-family: guardianfont;
        src: url(../fonts/GuardianSansRegular.otf);
    }


    /*Background*/
    .home {
        display: block;
        /*background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('../assets/bghome.png');
        height: 875px;*/
    }

    #videobg {
        object-fit: cover;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
    }

    /* Add mute button content at the bottom right of the page */
    #vidBtn {
        position: absolute;
        cursor: pointer;
        bottom: 5%;
        left: 85%;
        z-index: 9999;
        padding: 10px;
        margin: 50px auto;

        color: #ffffff;
        font-family: guardianfont;
        font-size: 18px;
        line-height: 30px;
        text-align: center;
        background-color: #005f4bd3;
    }


    /*Front Menu*/
    .menu {
        position: absolute;
        top: 25%;
        left: 10%;
    }

    .menu1, .menu2, .menu3 {
        display: flex;
        flex-direction: row;

        background-color: #005f4bd3;
        width: 300px;
        height: 100%;
        margin: 20px;
    }

    .menutext {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: flex-start;
        align-items: flex-start;
        margin-left: 10px;
        padding: 20px;
    }

    .menutext h1 {
        color: white;
        font-family: guardianfont;
        font-size: 30px;
        line-height: 10px;
        text-align: left;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .menutext p {
        color: white;
        font-family: guardianfont;
        font-size: 18px;
        line-height: 21px;
        text-align: left;
    }


    /*Hotspots and Buttons with Links*/
    /*in front menu*/
    /*#hotSpot1 {
        position: absolute;
        top: 7%;
        left: 87%;
    }*/

    #hotSpot2 {
        position: absolute;
        top: 10%;
        left: 87%;
    }

    /*#hotSpot3 {
        position: absolute;
        top: 71%;
        left: 87%;
    }*/

    /*not front menu*/
    #hotSpot4 {
        position: absolute;
        top: 51%;
        left: 64%;
    }

    #hotSpot5 {
        position: absolute;
        top: 70%;
        left: 47%
    }

    .hotSpots {
        background-image: url(../assets/hotSpot.png);
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #93ea20;
        
        padding: 22px;
        margin: 50px auto;
        border-radius: 50%;

        animation: glowGrow 3s ease-in-out infinite;
        transform: scale(1.5);
        cursor: pointer;
    }

    .mobileHomeLobby {
        display: none;
    }


    /* Desktop to Mobile Break */
    @media only screen and (max-width: 1200px) {

        .home {
            display: none;
        }

        .menu {
            display: none;
        }

        .hotSpots {
            display: none;
        }

        .mobileHomeLobby {
            display: block;
            height: 100%;
            width: 100%;
            background-color: #005f4be5;
        }

        .menuMobile {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            padding-top: 30px;
            padding-bottom: 30px;
        }

        .menuMobile a {
            text-decoration: none;
            width: 75%;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
        }

        .menu1Mobile, .menu2Mobile, .menu3Mobile, .menu4Mobile, .menu5Mobile {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 10px;
        }

        .menutextMobile {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
            align-items: center;
            padding: 20px;
            border-bottom: #ffffff solid 1px;
        }

        .menutextMobile h1 {
            color: white;
            font-family: guardianfont;
            font-size: 30px;
            line-height: 30px;
            text-align: center;
            padding-bottom: 10px;
        }

        .menutextMobile p {
            color: white;
            font-family: guardianfont;
            font-size: 18px;
            line-height: 21px;
            text-align: center;
        }

    }


    /*Hovers*/
    .hotSpots:hover {
        filter: grayscale(0.4);
    }

    #vidBtn:hover {
        color: #93ea20;
    }
    

    .menu1Mobile:hover, .menu2Mobile:hover, .menu3Mobile:hover, .menu4Mobile:hover, .menu5Mobile:hover  {
        background-color: #ffffff25;
        cursor: pointer;
    }


    /*Animations*/
    @keyframes glowGrow {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgb(146, 234, 31, 0.7);
        }
        
        70% {
            transform: scale(1);
            box-shadow: 0 0 0 25px rgb(146, 234, 31, 0);
        }
        
        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgb(147, 234, 32, 0);
        }
    }
</style>